import moment from 'moment';
import { VerifyPolicyInput } from '../../../redux/reducer/v2/verifyPolicy';

/**
 * Validates the quote data object. Important for Covie integration. If needed properties for Covie are missing, function will return false.
 * @param quoteData - The quote data object to validate.
 * @returns True if the quote data is valid, false otherwise.
 */
export function validateVerifyPolicyInputData(
  quoteData: VerifyPolicyInput | undefined,
): quoteData is VerifyPolicyInput {
  if (quoteData === undefined) {
    return false;
  }

  const { lastName, firstName, email, leaseStart, leaseEnd, address } = quoteData;

  if (
    !lastName ||
    !firstName ||
    !email ||
    !leaseStart ||
    !leaseEnd ||
    !address
  ) {
    return false;
  }

  const isValidStartDate = moment(leaseStart).isValid();
  const isValidEndDate = moment(leaseEnd).isValid();

  if (!isValidStartDate || !isValidEndDate) {
    return false;
  }

  return true;
}
